<template>
  <div>
    <el-form
      ref="form"
      :hide-required-asterisk="true"
      label-position="left"
      :rules="rules"
      label-width="200px"
      :model="form"
    >
      <el-form-item prop="userNo">
        <div slot="label">
          <div class="label-text">
            職員帳號
            <span class="star-mark">*</span>
          </div>
        </div>
        <el-input
          v-model="form.userNo"
          placeholder="請輸入職員帳號"
          class="fixed-with-330-input"
        >
        </el-input>
      </el-form-item>
      <el-form-item prop="name">
        <div slot="label">
          <div class="label-text">姓名</div>
        </div>
        <el-input
          v-model="form.name"
          placeholder="請輸入姓名"
          class="fixed-with-330-input"
        >
        </el-input>
      </el-form-item>
      <el-form-item prop="branchSchool">
        <div slot="label">
          <div class="label-text">分校 <span class="star-mark">*</span></div>
        </div>
        <el-select value-key="id" v-model="form.branchSchool" placeholder="請選擇分校">
          <el-option
            v-for="(item, index) in sortBranchesList"
            :key="index"
            :label="item.abbreviation"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <div slot="label">
          <div class="label-text">電話</div>
        </div>
        <el-input
          v-model="form.phone"
          placeholder="請輸入電話"
          class="fixed-with-330-input"
        >
        </el-input>
      </el-form-item>
      <el-form-item >
        <div slot="label">
          <div class="label-text">電郵</div>
        </div>
        <el-input
          v-model="form.email"
          placeholder="請輸入電郵"
          class="fixed-with-330-input"
        >
        </el-input>
      </el-form-item>
      <el-form-item prop="roleId">
        <div slot="label">
          <div class="label-text">
            權限
            <span class="star-mark">*</span>
          </div>
        </div>
        <el-select v-model="form.roleId" clearable placeholder="請選擇權限">
          <el-option
            v-for="(item, index) in $store.getters.roles.filter((v)=>{
                   return v.name !=='Parent' && v.name !=='Student'
                })"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="password">
        <div slot="label">
          <div class="label-text">
            密碼
            <span  class="star-mark"> *</span>
          </div>
        </div>
        <el-input
          v-model="form.password"
          placeholder="請輸入密碼"
          show-password
          class="fixed-with-330-input"
        >
        </el-input>
      </el-form-item>
      <el-form-item prop="confirmPassword">
        <div slot="label">
          <div class="label-text">
            確認密碼
            <span  class="star-mark"> *</span>
          </div>
        </div>
        <el-input
          v-model="form.confirmPassword"
          @input="onChange"
          placeholder="請輸入確認密碼"
          show-password
          class="fixed-with-330-input"
        >
        </el-input>
      </el-form-item>
      <div>請註意：標有 (<span class="star-mark">*</span>) 的為必填項。</div>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      default: function () {},
    },
  },
  data() {
    var validatePass = (rule, value, callback) => {
        if (this.form.password !== "") {
          this.$refs.form.validateField("confirmPassword");
        }
        callback();
    };
    var validatePass2 = (rule, value, callback) => {
      if (this.form.confirmPassword === "") {
        callback(new Error("请再次輸入密码"));
      } else if (value != this.form.password) {
        callback(new Error("和密碼不相同。"));
      } else {
        callback();
      }
    };
    return {
      roles: [],
      statuses: [],
      rules: {
        branchSchoolId: [{ required: true, message: "請選擇分校", trigger: "change" }],
        gender: [{ required: true, message: "", trigger: "change" }],
        userNo: [
          { required: true, message: "請輸入職員帳號", trigger: "change" },
        ],
        email: [
          { required: true, message: "请輸入电邮", trigger: "change" },
          {
            type: "email",
            required: true,
            message: "電郵格式錯誤。",
            trigger: "change",
          },
        ],
        password: [
          { required: true, message: "請輸入密碼", trigger: "change" },
          { validator: validatePass, trigger: "blur" },
          {
            message:
              "密碼必須介於 8-16 個字元之間，並且至少包含 1 個大寫字母 1 個小寫字母 1 個數字和 1 個特殊字符",
            pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)(?![^a-zA-Z0-9]+$).{8,16}$/,
            trigger: "blur",
          },
        ],
        confirmPassword: [{ validator: validatePass2, trigger: "blur" }],
        roleId: [{ required: true, message: "請選擇角色", trigger: "change" }],
      },
    };
  },

  methods: {
    onChange(){
      this.$forceUpdate()
    }
  },
};
</script>

<style lang="scss" scoped>
.label-text {
  font-size: 20px;
  line-height: 24px;
}

::v-deep {
  .el-input__inner {
    height: 53px;
  }
  .el-select {
    width: 330px;
  }
}

.fixed-with-330-input {
  width: 330px;
}

.fixed-with-141-input {
  width: 141px;
}

::v-deep {
  .el-form-item__content {
    line-height: 24px;
  }
}
</style>